import { RoomItemComponent } from './room-item';
import { RoomBreadcrumbPresenterComponent } from './room-breadcrumb-presenter';
import { RoomPresenterComponent } from './room-presenter';

export * from './room-item';
export * from './room-breadcrumb-presenter';
export * from './room-presenter';

export const RoomAtoms = [
    RoomItemComponent,
    RoomBreadcrumbPresenterComponent,
    RoomPresenterComponent
]